import { Pipe, PipeTransform } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Pipe({
  name: 'userImg'
})
export class UserImgPipe implements PipeTransform {

  constructor(private http: HttpClient) {}

  transform(url: any, args?: any): any {

      return this.http
      .get(url)
      .subscribe(res => {
        //return url if valid
        return url;
      });
    }
  

}
